export const appModalDataHooks = {
  MODAL_TITLE: 'baseModalLayout-title',
  MODAL_SUBTITLE: 'baseModalLayout-subtitle',
  EXPLORE_MORE_APPS_TEXT: 'explore-more-apps-text',
  EXPLORE_MORE_APPS_LINK: 'explore-more-apps-link',
  APP_MODAL_FOOTER_INFO_BADGE: 'app-modal-footer-info-badge',
  APP_MODAL_FOOTER_CTA: 'app-modal-footer-cta',
  LEARN_MORE_BUTTON: 'app-modal-learn-more-button',
};
